<template>
  <section class="banner">
    <div class="container">
      <a-typography-title :level="1">
        让计算像电一样随需使用
      </a-typography-title>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
export default {
  name: 'about_banner'
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/about/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{image}banner.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    width: 100%;
    height: 100%;
    padding: 160px 0 100px;
    margin: 0 auto;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, 80px, @color_white, 44px);
  .fontSpacing(15px);
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 100px 0 50px;
    }
  }
  
  h1.ant-typography {
    .font(center, 60px, @color_white, 36px);
    .fontSpacing(0);
  }
}

@media screen and (max-width: -1px+@grid_md) {
  h1.ant-typography {
    .font(center, 40px, @color_white, 26px);
    .fontSpacing(5px);
  }
}
</style>